import styled, { css } from 'styled-components';
export const Box = styled.div `
  position: relative;
  background-color: ${({ theme }) => theme.background};
  box-shadow:
    0 0 0 1px ${({ theme }) => theme.secondary.blendToBackground(1100, 50)},
    0 1px 2px rgba(0, 0, 0, 0.1);
  border-radius: 12px;

  ${({ theme }) => theme.id !== 'default' &&
    css `
      background-color: ${theme.secondary.blendToBackground(5)};
      box-shadow: 0 0 0 1px ${theme.secondary.blendToBackground(150)};
    `}

  ${({ variant }) => variant === 'secondary' &&
    css `
      border-radius: 8px;
      background-color: ${({ theme }) => theme.gray.blendToBackground(24)};
      box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);

      ${({ theme }) => theme.id !== 'default' &&
        css `
          box-shadow: 0 0 0 1px ${theme.secondary.blendToBackground(100)};
        `}
    `}

    ${({ padding }) => padding &&
    css `
      padding: 24px;
    `}

    ${({ paddingX }) => paddingX &&
    css `
      padding-right: 24px;
      padding-left: 24px;
    `}

    ${({ paddingY }) => paddingY &&
    css `
      padding-top: 24px;
      padding-bottom: 24px;
    `}
`;
//# sourceMappingURL=Box.js.map